import { useAuth } from '../../hooks/useAuth';

interface GuestCompletionPopupProps {
  isOpen: boolean;
  onDismiss: () => void;
}

/**
 * GuestCompletionPopup — overlay shown when an anonymous user completes a challenge.
 *
 * Visibility: detected via progress endpoint polling in GameFrame (IS-INV-034).
 * Non-blocking: user can dismiss and continue browsing.
 */
export function GuestCompletionPopup({ isOpen, onDismiss }: GuestCompletionPopupProps) {
  const { openAuthModal } = useAuth();

  if (!isOpen) return null;

  const handleSignUp = () => {
    openAuthModal('sign-up');
  };

  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="bg-surface border border-border rounded-xl p-8 max-w-sm mx-4 text-center shadow-xl">
        <h2 className="font-display text-2xl text-foreground mb-3 uppercase">
          Start your official streak
        </h2>
        <p className="text-muted-foreground text-sm mb-6 leading-relaxed">
          Sign up free to track your results and compete with friends
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={handleSignUp}
            className="w-full px-6 py-3 bg-sport-accent text-white rounded-md font-emphasis text-sm
                       font-medium uppercase-tracked hover:opacity-90 transition-opacity duration-200"
          >
            Sign Up Free
          </button>
          <button
            onClick={onDismiss}
            className="w-full px-6 py-2 text-muted-foreground font-emphasis text-sm
                       hover:text-foreground transition-colors duration-200"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
